import { Checkbox, Col, Divider, Typography } from "antd";
import { Controller, Control } from "react-hook-form";
import {
  ADMIN_MODULE_OPTIONS,
  ALL_ADMIN_MODULE_KEYS,
} from "../../config/adminModules";

const { Title, Text } = Typography;

type Props = {
  control: Control<any>;
  name?: string;
};

export const AdminModulesSelector = ({
  control,
  name = "allowed_modules",
}: Props) => {
  const grouped = ADMIN_MODULE_OPTIONS.reduce<
    Record<string, typeof ADMIN_MODULE_OPTIONS>
  >((acc, opt) => {
    const g = opt.group ?? "General";
    if (!acc[g]) acc[g] = [];
    acc[g].push(opt);
    return acc;
  }, {});

  return (
    <Col span={24} style={{ marginTop: 16 }}>
      <Title level={5} style={{ marginBottom: 4 }}>
        Módulos del sistema
      </Title>
      <Text type="secondary" style={{ display: "block", marginBottom: 8, fontSize: 12 }}>
        Si no seleccionas ninguno, el usuario verá todos los módulos (admin) o el
        menú reducido por defecto (vendedor).
      </Text>
      <Controller
        name={name}
        control={control}
        defaultValue={[]}
        render={({ field }) => {
          const value: string[] = Array.isArray(field.value) ? field.value : [];

          const setValue = (next: string[]) => field.onChange(next);

          const toggleAll = (checked: boolean) => {
            setValue(checked ? [...ALL_ADMIN_MODULE_KEYS] : []);
          };

          const allChecked =
            value.length > 0 &&
            ALL_ADMIN_MODULE_KEYS.every((k) => value.includes(k));

          return (
            <>
              <Checkbox
                checked={allChecked}
                indeterminate={
                  value.length > 0 && !allChecked
                }
                onChange={(e) => toggleAll(e.target.checked)}
                style={{ marginBottom: 8 }}
              >
                Seleccionar todos
              </Checkbox>
              <Checkbox.Group
                value={value}
                onChange={(checked) => setValue(checked as string[])}
                style={{ width: "100%" }}
              >
                {Object.entries(grouped).map(([group, options], idx) => (
                  <div key={group}>
                    {idx > 0 && <Divider style={{ margin: "12px 0" }} />}
                    {group !== "General" && (
                      <Text
                        strong
                        style={{ display: "block", marginBottom: 6, fontSize: 12 }}
                      >
                        {group}
                      </Text>
                    )}
                    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                      {options.map((opt) => (
                        <Checkbox key={opt.key} value={opt.key}>
                          {opt.label}
                        </Checkbox>
                      ))}
                    </div>
                  </div>
                ))}
              </Checkbox.Group>
            </>
          );
        }}
      />
    </Col>
  );
};
